import React from 'react';
import { Form } from 'react-bootstrap';

interface WorkOrderRequirementsCheckboxesProps {
    requiresPhoto: boolean;
    requiresComment: boolean;
    requiresConditionUpdate: boolean;
    onRequiresPhotoChange: (value: boolean) => void;
    onRequiresCommentChange: (value: boolean) => void;
    onRequiresConditionUpdateChange: (value: boolean) => void;
    /** Condition updates require at least one linked component. */
    hasLinkedComponents: boolean;
    heading?: string;
    /** Unique prefix for the checkbox ids (avoid collisions when two forms mount). */
    idPrefix?: string;
}

/**
 * The "requirements on completion" checkboxes for a work order. The condition-
 * update requirement is always shown but disabled until a component is linked,
 * with a hint explaining why. Shared by the create and edit work-order modals.
 */
export const WorkOrderRequirementsCheckboxes: React.FC<WorkOrderRequirementsCheckboxesProps> = ({
    requiresPhoto,
    requiresComment,
    requiresConditionUpdate,
    onRequiresPhotoChange,
    onRequiresCommentChange,
    onRequiresConditionUpdateChange,
    hasLinkedComponents,
    heading = 'Krav för slutförande',
    idPrefix = '',
}) => (
    <>
        {heading ? <h6>{heading}</h6> : null}
        <Form.Check
            type="checkbox"
            id={`${idPrefix}requires-photo`}
            label="Kräv efterfoto"
            checked={requiresPhoto}
            onChange={(e) => onRequiresPhotoChange(e.target.checked)}
            className="mb-2"
        />
        <Form.Check
            type="checkbox"
            id={`${idPrefix}requires-comment`}
            label="Kräv kommentar"
            checked={requiresComment}
            onChange={(e) => onRequiresCommentChange(e.target.checked)}
            className="mb-2"
        />
        <Form.Check
            type="checkbox"
            id={`${idPrefix}requires-condition-update`}
            label="Kräv skicksuppdatering"
            checked={requiresConditionUpdate}
            onChange={(e) => onRequiresConditionUpdateChange(e.target.checked)}
            disabled={!hasLinkedComponents}
            className="mb-2"
        />
        {!hasLinkedComponents && requiresConditionUpdate && (
            <Form.Text className="text-warning d-block">
                Skicksuppdatering kräver minst en länkad komponent
            </Form.Text>
        )}
    </>
);
